import { render, staticRenderFns } from "./icon_field.vue?vue&type=template&id=4689d420&lang=pug&"
import script from "./icon_field.vue?vue&type=script&lang=js&"
export * from "./icon_field.vue?vue&type=script&lang=js&"
import style0 from "./icon_field.vue?vue&type=style&index=0&id=4689d420&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports